module.exports = __webpack_public_path__ + "img/sport-5-640.959fc087.jpg";